// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  hitId: __t.u64().primaryKey().name("hit_id"),
  attacker: __t.identity(),
  target: __t.identity(),
  systemId: __t.string().name("system_id"),
  dmg: __t.f64(),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  at: __t.timestamp(),
});
